import leadingPositionImage from "../images/why-invest/2_helios_page_04_ribbon.png";
import contentImage from "../images/why-invest/content-fullwidth-05.jpg";

const WhyInvest = () => {
  return (
    <div>
      <h2 className="fs-28 gilroy-bold pb-5">Why Invest</h2>
      <div>
        <img src={contentImage} alt="loading..." className="img-fluid" />
        <p className="fs-16 lh-30 text-align-justify pt-5">
          Afro Towers has a strong platform for profitable growth, with leading
          positions in high-growth markets. We’re supported by our extensive
          asset base, a pioneering excellence and innovation programme, deep and
          long-term client relationships, high barriers to entry and a
          favourable regulatory environment.
        </p>
      </div>
      <div className="row pt-5">
        <div className="col-12 col-md-4">
          <img
            src={leadingPositionImage}
            alt="Market Leading Position"
            className="img-fluid d-block ms-start ms-md-auto"
          />
        </div>
        <div className="col-12 col-md-8 my-auto">
          <h3 className="fs-28 lh-30 my-5 fw-700">Market-leading positions</h3>
          <ul className="fs-16 lh-30">
            <li>
              Market-leading positions in four out of seven operational markets.
            </li>
            <li>
              Early market entry allowing for ownership of attractive sites in
              prime urban areas.
            </li>
            <li>
              Skills in reliable power management and tower planning/deployment.
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default WhyInvest;
